export const validateBannerForm = (data) =>{

    const requiredFields = [
        "bannerName",
        "bannerType",
        "clientName",
        "startDate",
        "endDate",
        // "imageUrl"
    ]

    var validFieldCount = 0
    
    requiredFields.forEach((field)=>{
        if(data[field]){
            validFieldCount = validFieldCount + 1
            // console.log(field , true)
        }else{
            // console.log(field , false)
        }
    })

    if(validFieldCount!==requiredFields.length){
        return false
    }

    if(data.adType === "video"){
        if(data.videoType === "local"){
            return Boolean(data.localVideoUrl)
        }

        return Boolean(data.bannerVideo)
    }

    if(Object.prototype.hasOwnProperty.call(data, "imageUrl")){
        return Boolean(data.imageUrl)
    }

    return true
}
